import { RouteEditTab } from "../../RouteEditTab";

export function isSelected(
  routeEditTabSelected: RouteEditTab,
  selectedSpdrOrPdsrId: number | undefined,
  spdrOrPdsrId: number | undefined
) {
  if (routeEditTabSelected === RouteEditTab.Ftl) {
    return false;
  }

  if (selectedSpdrOrPdsrId !== spdrOrPdsrId) {
    return false;
  }

  return true;
}
